import {Field} from 'formik';

import {Grid} from '@mantine/core';
import {
    FormikNumberInput,
} from "@flexinet/ui-components";
import {PricesAutocomplete} from "../../prices/inputs/PricesAutocomplete.tsx";
import {SubscriptionsAutocomplete} from "../../subscriptions/inputs/SubscriptionsAutocomplete.tsx";

export const FormComponent = () => {

    return (
        <Grid>

            <Grid.Col span={12}>
                <Field
                    name='subscription'
                    label='Subscription'
                    description='Please select the subscription'
                    component={SubscriptionsAutocomplete}
                    withAsterisk
                />
            </Grid.Col>

            <Grid.Col span={12}>
                <Field
                    name='price'
                    label='Price'
                    description='Please select the price'
                    component={PricesAutocomplete}
                    withAsterisk
                />
            </Grid.Col>

            <Grid.Col span={12}>
                <Field
                    name='quantity'
                    label='Quantity'
                    description='Please enter the quantity'
                    component={FormikNumberInput}
                />
            </Grid.Col>

        </Grid>
    );
};
